"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextTemplates = exports.TextTemplate = exports.MultilineNotes = void 0;
const MultilineNotes_yaml_component_1 = __importDefault(require("./MultilineNotes.yaml?component"));
exports.MultilineNotes = MultilineNotes_yaml_component_1.default;
const TextTemplate_yaml_component_1 = __importDefault(require("./TextTemplate.yaml?component"));
exports.TextTemplate = TextTemplate_yaml_component_1.default;
const TextTemplates_yaml_component_1 = __importDefault(require("./TextTemplates.yaml?component"));
exports.TextTemplates = TextTemplates_yaml_component_1.default;
